import * as React from 'react';
import {Chip} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledTag = styled(Chip)(({ theme }) => ({
    borderRadius: 0,
    padding: '0 8px',
    marginLeft: theme.spacing(1),
    height:25,
    border: 'none',
    borderLeft: `2px solid ${theme.palette.info.main}`,
    background: theme.palette.info.light,
    '& .MuiChip-label':{
        fontSize: '0.75rem!important',
        textTransform:'uppercase',
        padding: '0',
    }
}));

export const Tags = ({ items, name, ...props }) => {
    return (
        <>
            {items?.length > 0 ?
                items.map((item, index) => (
                    <StyledTag
                        {...props}
                        key={index}
                        label={item[name]}
                        variant="outlined"
                        size="small"
                        color={item.color ?? 'primary'}
                    />
                ))
                :
                <>-</>
            }
        </>
    );
};
